import React from "react";
import { FaFacebookF, FaInstagram } from "react-icons/fa";

const SocialLinks = () => {
  const links = [
    {
      href: "https://www.facebook.com/profile.php?id=100063601626814",
      icon: FaFacebookF,
      label: "Facebook",
    },
    {
      href: "https://www.instagram.com/aucoingduventoux/",
      icon: FaInstagram,
      label: "Instagram",
    },
  ];

  return (
    <section className="py-16 md:py-20" style={{ backgroundColor: '#F4ECDD' }}>
      <div className="text-center mb-10">
        <span className="text-xs font-semibold tracking-[0.3em] uppercase text-amber-800">
          Suivez-nous
        </span>
        <h2 className="font-sans mt-3 text-2xl md:text-3xl text-stone-800">
          Retrouvez-nous sur les réseaux
        </h2>
      </div>

      <div className="flex justify-center gap-6">
        {links.map(({ href, icon: Icon, label }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            className="group flex items-center justify-center w-16 h-16 rounded-full border-2 transition-all duration-300 hover:scale-110"
            style={{
              borderColor: 'rgba(120,90,40,0.35)',
              backgroundColor: 'white',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = '#2E2318';
              e.currentTarget.style.borderColor = '#2E2318';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = 'white';
              e.currentTarget.style.borderColor = 'rgba(120,90,40,0.35)';
            }}
          >
            <Icon className="text-xl transition-colors duration-300 text-stone-700 group-hover:text-white" />
          </a>
        ))}
      </div>
    </section>
  );
};

export default SocialLinks;